import { ModalSizes } from './types/modalTypes'

export const MODAL_ROOT_ID = 'modal-root'
export const DEFAULT_MODAL_SIZE = ModalSizes.MD
